module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/8m-625edc3fd1636cff7232d6bc538abbab.jpg";